export const apiTypes = ['forms', 'websites', 'segments'];
